import React from "react";
import LiveWaitingIndicator from "../shared/LiveWaitingIndicator";
import LeftSideBar from "../shared/LeftSideBar";
import { LeftSideBarCol } from "../shared/LeftSideBarSpacing";
import TileStep from "../shared/TileStep";
import UnifiedAPIExplorer from "./UnifiedAPIExplorer";
import useDashboardOnboardingStatus from "../../hooks/useDashboardOnboardingStatus";
import { Text } from "@merge-api/merge-javascript-shared";
import { ReactComponent as DownloadImage } from "../../assets/download-image.svg";

const APIRequestSection = () => {
  const dashboardOnboardingStatus = useDashboardOnboardingStatus();

  return (
    <div className="flex flex-col w-full">
      <Text variant="h3" className="mb-6">
        Make API request
      </Text>
      <div className="flex flex-row">
        <LeftSideBar stepNumber="1" isNormalStep={false} />
        <TileStep
          img={
            <div className="relative flex justify-center items-center bottom-[9px]">
              <DownloadImage height={80} className="absolute" />
              <div className="absolute top-[35px]">
                {dashboardOnboardingStatus?.has_pulled_common_model_data ? (
                  <LiveWaitingIndicator color="green" />
                ) : (
                  <LiveWaitingIndicator color="red" />
                )}
              </div>
            </div>
          }
          title="Pull data from Unified API"
          subtitle={
            <>
              <p className="mb-[9px]">
                Use the interface below to learn how to authenticate API requests to the Unified
                API.
              </p>
              Pull any synced data via GET request to the Unified API to finish this step!
            </>
          }
          stepNumber={1}
        />
      </div>
      <div className="flex flex-row">
        <LeftSideBarCol className="items-center" />
        <UnifiedAPIExplorer />
      </div>
    </div>
  );
};

export default APIRequestSection;
